import { SnapshotService } from './../snapshot/snapshot.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserRecordField, UserRecordModel, WebApiEndpoints, SimulationProcessingRequest, SimulationProcessingResult, convertFromConstantToHuman } from '@liquitics/transaction';
import { ConfirmationService } from 'primeng/api';
import { MenuItem } from 'primeng/api/menuitem';
import { SelectItem } from 'primeng/api/selectitem';
import { FileUpload } from 'primeng/fileupload';
import { AppConfig } from '../app.config';
import { AwsUtil } from '../authentication/aws.service';
import * as moment from 'moment';

interface DataCell {
    value: string;
    isError: boolean;
}

@Component({
    selector: 'app-simulation',
    templateUrl: './simulation.component.html',
    styleUrls: ['./simulation.component.scss']
})
export class SimulationComponent implements OnInit {
    batchIdentifier: string;
    operatingDate: Date;
    maxOperatingDate: Date;
    @ViewChild('fileChooser') fileChooser: FileUpload;
    simulationType: string;
    simulationTypes: any[];
    recordModels: UserRecordModel[];
    menuItems: MenuItem[];
    downloadTemplateUrl: any;
    errorMessages: string[] = [];
    loading = false;
    running = false;
    loadedXlsxBase64Data: string;

    runStatus: string;
    licensedCount: number;
    completedCount: number;


    constructor(
        private appConfig: AppConfig,
        private snapshotService: SnapshotService,
        private awsUtil: AwsUtil,
        private sanitizer: DomSanitizer,
        private confirmationService: ConfirmationService,
    ) {
    }

    // async downloadTemplate() {

    //     const models = await this.getUserRecordModels();
    //     const templateData = models
    //         .map((model) => {
    //             return 
    //         });
    //     const buffer = Buffer.from(previewResult.xlsxBase64Output, 'base64');
    //     const blobType = 'text/csv';
    //     const blob: any = new Blob([buffer], { type: blobType });
    //     this.downloadTemplateUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
    // }

    async ngOnInit() {
        this.batchIdentifier = this.snapshotService.getDefaultBatchIdentifier();

        this.operatingDate = this.appConfig.getTodayStartUTC().toDate();
        this.maxOperatingDate = this.operatingDate;

        // const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        // this.isReportingAdmin = reportingProfile.isReportDashboardAdmin();
        // this.license = reportingProfile.getLicense();
        this.simulationTypes = ['BALANCE_SHEET_TRADING', 'BALANCE_SHEET_RISK_MANAGEMENT', 'BALANCE_SHEET_STRESS_TESTING', 'BALANCE_SHEET_PLANNING', 'FUNDING_PLANNING']
            .map((simulationType) => {
                return { label: convertFromConstantToHuman(simulationType), value: simulationType, licensed: true };
            });
        this.simulationType = this.simulationTypes
            .find((simulationType) => {
                return simulationType.licensed;
            }).value;
        const params = {
            type: 'TEMPLATE',
        } as SimulationProcessingRequest;
        const results: SimulationProcessingResult = await this.awsUtil.webAPICall(WebApiEndpoints.ProcessSimulationData, params, true);
        const buffer = Buffer.from(results.xlsxBase64Data, 'base64');
        const blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob: any = new Blob([buffer], { type: blobType });
        this.downloadTemplateUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));

        this.recordModels = results.models;

        // const temmplateMaenuItems = models
        //     .map((model) => {
        //         return {
        //             label: model.displayName, icon: 'pi pi-download', command: (event) => {
        //                 const buffer = Buffer.from(previewResult.xlsxBase64Output, 'base64');
        //                 const blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        //                 const blob: any = new Blob([buffer], { type: blobType });
        //                 this.inventoryUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
        //                 this.inventoryFileName = `${previewFileName}-inventory.xlsx`;
        //             }
        //         }
        //     })
        // this.menuItems = [
        //     {
        //         label: 'Download Template',
        //         items: [{
        //             label: 'Download ',
        //             icon: 'pi pi-fw pi-plus',
        //             items: [
        //                 { label: 'Project' },
        //                 { label: 'Other' },
        //             ]
        //         },
        //         { label: 'Open' },
        //         { label: 'Quit' }
        //         ]
        //     },
        //     {
        //         label: 'Edit',
        //         icon: 'pi pi-fw pi-pencil',
        //         items: [
        //             { label: 'Delete', icon: 'pi pi-fw pi-trash' },
        //             { label: 'Refresh', icon: 'pi pi-fw pi-refresh' }
        //         ]
        //     }
        // ];
    }

    parseValidatedModelData(model: UserRecordModel, data: any[]): any[] {
        return data
            .map((row) => {
                Object.keys(row)
                    .forEach((key: string) => {
                        const value: string = row[key];
                        const dataCell = {
                            value
                        } as DataCell;
                        row[key] = dataCell;
                        if (value.startsWith('INVALID_DATE:')) {
                            dataCell.value = value.substring('INVALID_DATE:'.length);
                            dataCell.isError = true;
                        } else if (value.startsWith('INVALID_VALUE:')) {
                            dataCell.value = value.substring('INVALID_VALUE:'.length);
                            dataCell.isError = true;
                        } else if (value.startsWith('MISSING_VALUE:')) {
                            dataCell.value = '<REQUIRED>';
                            dataCell.isError = true;
                        }
                    });
                return row;
            })
    }

    handleSimulationFileUpload(event) {
        for (const file of event.files) {
            // push to s3
            // refresh local avatar
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = (evt: Event) => {
                const dataStr = fileReader.result as string;
                const dataWithoutHeader = dataStr.substring(dataStr.indexOf(',') + 1);
                const params = {
                    type: 'VALIDATE',
                    xlsxBase64Data: dataWithoutHeader
                } as SimulationProcessingRequest;
                this.loading = true;
                this.awsUtil.webAPICall(WebApiEndpoints.ProcessSimulationData, params, true)
                    .then((response: SimulationProcessingResult) => {
                        this.errorMessages = response.errorMessages || [];
                        Object.keys(response.parsedDataByType)
                            .forEach((modelType) => {
                                const data: any[] = response.parsedDataByType[modelType];
                                if (data && data.length > 0) {
                                    const recordModel = this.recordModels
                                        .find((rm) => {
                                            return rm.name === modelType;
                                        });
                                    if (recordModel) {
                                        (recordModel as any).data = this.parseValidatedModelData(recordModel, data);
                                    }
                                }
                            });
                    })
                    .finally(() => {
                        this.loading = false;
                        this.fileChooser.clear();
                        if (this.errorMessages.length === 0) {
                            this.loadedXlsxBase64Data = dataWithoutHeader;
                        } else {
                            this.loadedXlsxBase64Data = undefined;
                        }
                    });
            };
        }
    }

    async updateStatus() {
        const statusRequest = {
            type: 'RUN_STATUS',
            batchIdentifier: this.batchIdentifier,
            simulationType: this.simulationType,
            xlsxBase64Data: this.loadedXlsxBase64Data
        } as SimulationProcessingRequest;
        return this.awsUtil.webAPICall(WebApiEndpoints.ProcessSimulationData, statusRequest, true)
            .then((response: SimulationProcessingResult) => {
                this.runStatus = response.simulationRunStatus;
                this.licensedCount = response.licensedSimulationRunCount;
                this.completedCount = response.completedSimulationRunCount;
                this.errorMessages = response.errorMessages || [];
            });
    }

    doRunSimulation() {
        this.confirmationService.confirm({
            message: `Are you sure you wish to submit these definitions and start a ${convertFromConstantToHuman(this.simulationType)} Simulation run?`,
            header: `Submit & Start Simulation Run?`,
            icon: 'pi pi-question',
            acceptLabel: `Submit & Start`,
            accept: () => {
                this.running = true;
                this.updateStatus()
                    .then(() => {
                        if (this.runStatus === 'RUNNING') {
                            this.confirmationService.confirm({
                                message: `Simulation is currently still running. Please wait for completion before starting a new run.`,
                                header: `Already Running`,
                                icon: 'pi pi-info',
                                acceptLabel: `OK`,
                                rejectVisible: false,
                            });
                            this.running = false;
                            return;
                        }
                        if (this.completedCount >= this.licensedCount) {
                            this.confirmationService.confirm({
                                message: `${this.completedCount}-of-${this.licensedCount} licensed runs have already been used.`,
                                header: `No Runs Remaining`,
                                icon: 'pi pi-info',
                                acceptLabel: `OK`,
                                rejectVisible: false,
                            });
                            this.running = false;
                            return;
                        }
                        const submitRequest = {
                            type: 'SUBMIT',
                            batchIdentifier: this.batchIdentifier,
                            simulationType: this.simulationType,
                            xlsxBase64Data: this.loadedXlsxBase64Data
                        } as SimulationProcessingRequest;
                        this.awsUtil.webAPICall(WebApiEndpoints.ProcessSimulationData, submitRequest, true)
                            .then((response: SimulationProcessingResult) => {
                                this.errorMessages = response.errorMessages || [];
                            })
                            .finally(() => {
                                this.running = false;
                            });
                    });
            },
            reject: () => {
            }
        });
    }

    doCheckStatus() {
        this.running = true;
        this.updateStatus()
            .then(() => {
                let message;
                if (this.runStatus === 'NOT_STARTED') {
                    message = `Simulation for ${convertFromConstantToHuman(this.simulationType)} has not been run for ${this.batchIdentifier}.`;
                } else if (this.runStatus === 'RUNNING') {
                    message = `Simulation for ${convertFromConstantToHuman(this.simulationType)} is currently still Running.`;
                } else if (this.runStatus === 'FAILED' || this.runStatus === 'TIMED_OUT') {
                    message = `Latest simulation run for ${convertFromConstantToHuman(this.simulationType)} has Failed}.`;
                } else if (this.runStatus === 'ABORTED') {
                    message = `Latest simulation run for ${convertFromConstantToHuman(this.simulationType)} has been Aborted}.`;
                } else if (this.runStatus === 'SUCCEEDED') {
                    message = `Simulation run for ${convertFromConstantToHuman(this.simulationType)} has Succeeded and results are available.`;
                } else {
                    message = `Unknown status for simulation run ${convertFromConstantToHuman(this.simulationType)}.`;
                }
                message += `\n${this.completedCount}-of-${this.licensedCount} licensed runs have been used.`;
                this.confirmationService.confirm({
                    message,
                    header: `Status`,
                    icon: 'pi pi-info',
                    acceptLabel: `OK`,
                    rejectVisible: false,
                });


            })
            .finally(() => {
                this.running = false;
            });
    }

    onSimulationTypeChange(event) {
        this.running = true;
        this.updateStatus()
            .finally(() => {
                this.running = false;
            });
    }

    getBatchIdentifierForSelectedDate(): string {
        const biParts = this.batchIdentifier.split('_');
        biParts[0] = moment(this.operatingDate).format('YYYY-MM-DD');
        return biParts.join('_');
    }
    onOperatingDateSelected(event) {
        this.batchIdentifier = this.getBatchIdentifierForSelectedDate();
    }
}

// TODO
// Batch Identifier
// Status
// Licensing
// Run Counter